import { Component, ViewChild } from '@angular/core';
import { NavController,  IonInfiniteScroll, LoadingController} from '@ionic/angular';
import { ResultProvider, ResultSearchModel, RanglistListModel, RanglistSearchModel, ResultSearchAdvancedModel } from '../../../providers/result/result';
import { EventTievts, EventProvider, EventDetailsModel } from '../../../providers/event/event';
import { LoaderProvider } from '../../../providers/loader/loader';
import { TranslateService } from '@ngx-translate/core';
import { ValueProvider } from '../../../providers/value/value';
import { SessionProvider } from '../../../providers/session/session';
import { GlobalUtil } from '../../../tracker/global-utils';
import { AppDetectorProvider } from '../../../providers/detector/detector';
import { ConfigProvider } from '../../../providers/config/config';
import { Router } from '@angular/router';

/**
 * Generated class for the ResoultRanglistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
    selector: 'page-result-event-details',
    templateUrl: 'result-event-details.html',
    styleUrls:['./result-event-details.scss']
})
export class ResultEventDetailsPage {
    @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
    headerScrollConfig = {
        maxHeight: 300,
        hideDuration: 300,
        showDuration: 300
    };
    searchModel: ResultSearchAdvancedModel = { eid: '', ena: '', city: '', dt: '', dist: '', t: '', sw: '', page: null, start: null, limit: null };
    savedSearch: ResultSearchAdvancedModel;

    event: EventTievts;
    list: RanglistListModel[] = [];

    search: RanglistSearchModel;
    results: any;

    eventDates: any = [];
    eventDistances: any = [];
    eventTypes: any = [];

    isBrowser: boolean = false;

    constructor(public navCtrl: NavController,
        public router:Router,
        public eventService: EventProvider,
        public resultService: ResultProvider,
        public valueService: ValueProvider,
        public loadingCtrl: LoadingController,
        public translate: TranslateService,
        private sessionService: SessionProvider,
        private appDetector: AppDetectorProvider,
        private config: ConfigProvider) {

    }

    onSearch() {
        console.log(this.event);
        this.searchModel.page = null;
        this.searchModel.start = '0';
        this.searchModel.limit = '25';

        this.getResults();
    }

    getResults() {
        console.log(this.searchModel);
        this.valueService.getResultsRangList(this.searchModel).then(data => {
            this.list = data.sort((a, b) => a.place - b.place);
            console.log('list: ', this.list);
        });
    }

    onDateChanged() {
        console.log(this.searchModel);
        this.valueService.getUserWithResults(this.searchModel.ena, this.searchModel.city, this.searchModel.dt).then(distances => {
            this.eventDistances = distances;
            if (distances.length > 0) {
                this.searchModel.dist = distances[0].value;
                this.onDistChanged();
            }
        });
    }

    onDistChanged(event?:any) {
        if(event){
            this.searchModel.dist = event.detail.value;
        }
        console.log(this.searchModel);

        this.valueService.getUserEventTypeWithResults(this.searchModel.ena, this.searchModel.city, this.searchModel.dt, this.searchModel.dist).then(types => {
            this.eventTypes = types;
            if (types.length > 0) {
                this.searchModel.t = types[0].value;
            }
            this.onSearch();
        });
    }

    onTypeChanged(event?:any) {
        if(event){
            this.searchModel.t = event.detail.value;
        }
        this.onSearch();
    }

    onInputChange(event?:any) {
        if(event){
            this.searchModel.sw = event.detail.value;
        }
        this.onSearch();
    }

    async ionViewWillLoad() {
        let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
        loader.present();

        const nav = this.router.getCurrentNavigation();
        const state = nav?.extras?.state || {};
        this.event = state['eventDetails'];
        this.search = state['search'];

        GlobalUtil.getInstance().currentEventID = this.event.id;

        this.valueService.getEventDatesWithResults(this.event.eventName, this.event.ort).then(dates => {
            this.eventDates = dates;

            this.valueService.getUserWithResults(this.event.eventName, this.event.ort, this.eventDates[this.eventDates.length - 1].value).then(distances => {
                this.eventDistances = distances;

                this.valueService.getUserEventTypeWithResults(this.event.eventName, this.event.ort, this.eventDates[this.eventDates.length - 1].value, this.eventDistances[this.eventDistances.length - 1].value).then(types => {
                    this.eventTypes = types;

                    this.searchModel.eid = this.event.id;
                    this.searchModel.ena = this.event.eventName;
                    this.searchModel.city = this.event.ort;
                    this.searchModel.dt = this.eventDates[0].value;
                    this.searchModel.dist = this.eventDistances[this.eventDistances.length - 1].value;
                    this.searchModel.t = this.eventTypes[this.eventTypes.length - 1].value;

                    loader.dismiss();
                });
            });
        });

    }

    isLoged() {
        return this.sessionService.isLoged;
    }

    async onBack() {
        this.isBrowser = (await this.config.config).platform.browser;

        if (this.appDetector.isEventsApp() && this.isBrowser) {
            // (this.app.getRootNav() as NavController).pop();
            this.navCtrl.back();
        } else {
            this.navCtrl.navigateForward('/tab1');
            // this.navCtrl.popToRoot();
            // this.app.getRootNav().getActiveChildNav().select(1);
        }
    }

    async showLogin() {
        let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
        loader.present();
        let profile = this.sessionService.isLoged ? this.sessionService.profile : null;
        this.valueService.getProfileBackgrounds().then(backgrounds => {
            // (this.app.getRootNav() as NavController)
            //     .push(MysportUserProfilePage, { data: { profile: profile, backgrounds: backgrounds } })
            this.navCtrl.navigateForward('/tab2/me/mysport/user-profile', {state:{data: { profile: profile, backgrounds: backgrounds }}})
                .then(() => loader.dismiss());
        });
    }

    profileImage(): string {
        return this.sessionService.profile.profilePicLink || 'assets/imgs/default-image-32@1x.png';
    }

    loadNextPage(event: any) {
        const infiniteScroll = event.target as IonInfiniteScroll;
        this.valueService.getResultsRangList(this.searchModel).then(data => {
            console.log('data: ', data);
            this.list = data;
            // this.list = this.list.concat(data);
            // console.log('this.list: ', this.list);
            // this.list = this.list.sort((a, b) => a.place - b.place);
            infiniteScroll.complete();
        });
    }
}
